export default "/_next/static/chunks/fonts/DAZN Oscine Light-7801d1cc62f72776a0195f85e198cf23.ttf";